// Shared image asset map — kept in its own module to avoid circular imports
// between `site.js` (brand + legacy data) and `catalog.js` (product catalog).
export const IMAGES = {
  heroShowroom: "/images/hero-image.webp",
  contactus:"/images/contactus.webp",
  manufacturingImage: "/images/manufacturing1.webp",
  manufacturing: "/images/manufacturing-poster.webp",
  AboutsUS:"/images/aboutus.webp",
  Glides: "/images/products/glide-s.webp",
  GlideHero: "/images/glidehero.webp",
  GlideVertical: "/images/products/glide-vertical.webp",
  GlideDuo: "/images/products/glide-duo.webp",
  Gallery: "/images/gallery.webp",
  Homec2c: "/images/homec2c.webp",
  logo:"/images/logo.webp",
  PrivacyTerm:"/images/termprivacy.webp",
  Product:"/images/product.webp"
};
